import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiTooltip = {
  defaultProps: { placement: 'top' },
  styleOverrides: {
    tooltip: { backdropFilter: 'blur(6px)', fontSize: '1rem' },
  },
} satisfies Components<Theme>['MuiTooltip'];
